import PropTypes from 'prop-types';
export const columnParamType = PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  S: PropTypes.number,
  M: PropTypes.number,
  L: PropTypes.number
})]);
export const responsiveTemplateType = PropTypes.shape({
  S: PropTypes.string,
  M: PropTypes.string,
  L: PropTypes.string
});
export const commonTemplateType = PropTypes.oneOfType([PropTypes.string, responsiveTemplateType]);